import React from "react"

import IconBlock from '../../../c/IconBlock/IconBlock'

import * as st from './ItemInfo.styled.js'

const ItemInfo = ({
  className,
  description,
  feature1Name,
  feature2Name,
  Feature1Icon,
  Feature2Icon,
}) => (
  <st.Wrap className={className}>
    <st.Text>
      {description}
    </st.Text>
    <st.Footer>
      <st.Feature>
        <IconBlock
          Icon={Feature1Icon}
        />
        {feature1Name}
      </st.Feature>
      {Feature2Icon && (
        <st.Feature>
          <IconBlock
            Icon={Feature2Icon}
          />
          {feature2Name}
        </st.Feature>
      )}
    </st.Footer>
  </st.Wrap>
)

export default ItemInfo
